import { DISALLOWED_COLOR_VALUES as e } from "../../constants.js";
import { tinycolor as t } from "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
//#region src/specs/nodes/spec-util.ts
var n = (n) => {
	if (n) {
		let r = t(n);
		if (r.isValid() && !e.includes(n)) return r.toHexString();
	}
	return "";
};
//#endregion
export { n as getBackgroundColor };
